import type { StoreType } from '@mimir/web/store/state';
import type { SubclipInfo, UiDownloadConfig } from '../store/uiDownload';
import type { FeatureFlag } from '@mimir/common/util/featureSet';
import type { ApplicationContext} from '@mimir/common/context/applicationContext';
import { isInAdobeApp, isInElectron } from '@mimir/common/context/applicationContext';

export function getUiDownloadConfig(
  applicationContext: ApplicationContext,
  store: StoreType,
  subclipInfo: SubclipInfo | undefined
): UiDownloadConfig {
  const featureFlags : Partial<Record<FeatureFlag, boolean>> | undefined = store.getters.featureFlags;
  return {
    isProxyMode: store.getters.isProxyWorkflowEnabled,
    isStandaloneMode: store.getters.selectedStorageProfile.isStandaloneMode,
    isPartialHighresDownloadEnabled: store.getters.isPartialHighresDownloadEnabled,
    isProxyOnlyOptimizationsEnabled: store.getters.isProxyOnlyOptimizationsEnabled,
    remuxTsToMp4: (featureFlags?.remuxTsToMp4InPremiere ?? false) && isInAdobeApp(applicationContext),
    subclipInfo,
    wantGrowingArtifact:
      !store.getters.timeline.hasMarkOut() &&
      isInElectron(applicationContext) &&
      applicationContext.dvrMode,
    subclipExpansionRoom: store.getters.selectedStorageProfile.subclipExpansionRoom,
  };
}
